// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.au-bleed-area {
  margin-inline: calc(var(--admin-shell-pad-x) * -1);
}
`, "",{"version":3,"sources":["webpack://./src/components/Admin/ui/AdminBleedArea.css"],"names":[],"mappings":"AAAA;EACE,kDAAkD;AACpD","sourcesContent":[".au-bleed-area {\n  margin-inline: calc(var(--admin-shell-pad-x) * -1);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
